<template>
  <div class="pt-6">
    <categoryselector ref="category" :multiAdsCat="false" :page-name="namePage" @category-schema="getSchema"
                      @category-fields="getFields" @category-current="getCurrent"/>

    <v-col class="mx-auto pa-0" cols="12" lg="6" md="8">
      <city-selector ref="city" :force="true"/>
    </v-col>

    <v-col class="mx-auto pa-0" cols="12" lg="6" md="8">
      <pic-selector/>
    </v-col>

    <input-maker ref="inputs" :fields="fields" :param="schema" :ui_schema="ui_schema"/>

    <setting-ads :timeRequire="true"/>

    <v-col class="mx-auto pa-0" cols="12" lg="6" md="8">
      <v-card-actions class="justify-end">
        <v-btn :loading="loading" class="submit-btn" @click="authenticate">
          <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
          ثبت آگهی
        </v-btn>
      </v-card-actions>
    </v-col>
  </div>
</template>

<script>
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import SettingAds from "@/view/pages/ads/settingAds";
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {Bus} from "@/main";
import Swal from "sweetalert2";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
  name: "createDefault",
  components: {
    ButtonTempl,
    TitleRibbon,
    PicSelector,
    SettingAds,
    InputMaker,
    AdsSelector,
    Inputs,
    Automatics,
    CitySelector,
    Categoryselector
  },
  props: {
    ui_schema: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
    multi_time: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: "ارسال آگهی تکی"
    },

  },
  data() {
    return {
      picker: '',
      submitMessage: '',
      namePage: this.pageName,
      auto: false,
      loading: false,
      schema: {
        category: "",
        location: {
          city: "",
          neighborhood: ""
        },
        contact: {
          chat_enabled: true,
          hide_phone: false,
          phone: null
        },
      }
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getCurrent: function (value) {
      this.current = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    authenticate() {
      this.$modal.showLoading();
      this.loading = true
      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.authenticate,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-type": 'application/json'
        },
        data: JSON.stringify({
          "title": this.schema['title'],
          "city": String(this.schema.location.city),
          "category": this.schema.category
        }),
        msg: false,
        error: (data) => {
          if (data.status === 422) {
            this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
          } else {
            this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
          }
          this.loading = false
        },
        success: (data) => {
          this.submitAds();
          this.loading = false
        }
      });

    },
    submitAds() {
      const data = this.schema;

      if (!this.$refs.inputs.validate() || !this.$refs.city.validate())
        return;
      if (data.location.neighborhood === "" || data.location.neighborhood === null || data.location.neighborhood === undefined)
        delete data.location.neighborhood;
      $.ajax({
        url: `${url}/default`,
        method: "POST",
        fn: this.submitAds,
        headers: {
          Authorization: Token,
          ACCEPT: 'application/json',
          "Content-Type": "application/json"
        },
        msg: true,
        data: JSON.stringify({
          data: {
            advertise: data,
            "auto_pay": this.auto
          },
          type: "advertise"
        }),
      });
    }
  },
  mounted() {
    Bus.$on('cityInfo', (value) => {
      this.schema.location.city = value.city;
      if (value.neighborhood != null || value.neighborhood != '') {
        this.schema.location.neighborhood = value.neighborhood;
      }
    });

    Bus.$on('selectedImage', (value) => {
      this.schema.images = value;
    });

    Bus.$on('contact', (value) => {
      this.schema.contact.chat_enabled = value.chat_enabled;
      this.schema.contact.hide_phone = value.hide_phone;
      this.auto = value.autoPay;
    });

    Bus.$on('category-current', (current) => {
      this.schema.category = current;
    });
  }
}
</script>

<style scoped>

</style>